// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const OLD_OUTAGES_ACTIONS = {
	// Import File
	OO_IMPORT_REQUEST: 'OO_IMPORT_REQUEST',
	OO_IMPORT_SUCCESS: 'OO_IMPORT_SUCCESS',
	OO_IMPORT_FAILURE: 'OO_IMPORT_FAILURE',

	// Get Last Update
	OO_GET_LAST_UPDATE_REQUEST: 'OO_GET_LAST_UPDATE_REQUEST',
	OO_GET_LAST_UPDATE_SUCCESS: 'OO_GET_LAST_UPDATE_SUCCESS',
	OO_GET_LAST_UPDATE_FAILURE: 'OO_GET_LAST_UPDATE_FAILURE',

	// Completion Overdue
	OO_COMPLETION_OVERDUE_REQUEST: 'OO_COMPLETION_OVERDUE_REQUEST',
	OO_COMPLETION_OVERDUE_SUCCESS: 'OO_COMPLETION_OVERDUE_SUCCESS',
	OO_COMPLETION_OVERDUE_FAILURE: 'OO_COMPLETION_OVERDUE_FAILURE',

	// Ending Today
	OO_ENDING_TODAY_REQUEST: 'OO_ENDING_TODAY_REQUEST',
	OO_ENDING_TODAY_SUCCESS: 'OO_ENDING_TODAY_SUCCESS',
	OO_ENDING_TODAY_FAILURE: 'OO_ENDING_TODAY_FAILURE',

	// Partner Restricted
	OO_PARTNER_RESTRICTED_REQUEST: 'OO_PARTNER_RESTRICTED_REQUEST',
	OO_PARTNER_RESTRICTED_SUCCESS: 'OO_PARTNER_RESTRICTED_SUCCESS',
	OO_PARTNER_RESTRICTED_FAILURE: 'OO_PARTNER_RESTRICTED_FAILURE',

	// Partner Restricted Blacklist
	OO_PARTNER_RESTRICTED_BLACKLIST_REQUEST: 'OO_PARTNER_RESTRICTED_BLACKLIST_REQUEST',
	OO_PARTNER_RESTRICTED_BLACKLIST_SUCCESS: 'OO_PARTNER_RESTRICTED_BLACKLIST_SUCCESS',
	OO_PARTNER_RESTRICTED_BLACKLIST_FAILURE: 'OO_PARTNER_RESTRICTED_BLACKLIST_FAILURE',

	// Partners Emails
	OO_PARTNERS_EMAILS_REQUEST: 'OO_PARTNERS_EMAILS_REQUEST',
	OO_PARTNERS_EMAILS_SUCCESS: 'OO_PARTNERS_EMAILS_SUCCESS',
	OO_PARTNERS_EMAILS_FAILURE: 'OO_PARTNERS_EMAILS_FAILURE',
};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Import File
export const ooImportRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_IMPORT_REQUEST });
export const ooImportSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_IMPORT_SUCCESS, payload });
export const ooImportFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_IMPORT_FAILURE, error });

// Get Last Update
export const ooGetLastUpdateRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_REQUEST });
export const ooGetLastUpdateSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_SUCCESS, payload });
export const ooGetLastUpdateFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_FAILURE, error });

// Completion Overdue
export const ooCompletionOverdueRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_REQUEST });
export const ooCompletionOverdueSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_SUCCESS, payload });
export const ooCompletionOverdueFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_FAILURE, error });

// Ending Today
export const ooEndingTodayRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_REQUEST });
export const ooEndingTodaySuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_SUCCESS, payload });
export const ooEndingTodayFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_FAILURE, error });

// Partner Restricted
export const ooPartnerRestrictedRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_REQUEST });
export const ooPartnerRestrictedSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_SUCCESS, payload });
export const ooPartnerRestrictedFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_FAILURE, error });

// Partner Restricted Blacklist
export const ooPartnerRestrictedBlacklistRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_REQUEST });
export const ooPartnerRestrictedBlacklistSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_SUCCESS, payload });
export const ooPartnerRestrictedBlacklistFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_FAILURE, error });

// Partners Emails
export const ooPartnersEmailsRequest = ()        => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_REQUEST });
export const ooPartnersEmailsSuccess = (payload) => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_SUCCESS, payload });
export const ooPartnersEmailsFailure = (error)   => ({ type: OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_FAILURE, error });